export default function () {
  // 企业 客户基本信息
  const companyBasicInfoList = [
    { key: 'businessLicenceUrl', name: '营业执照（照片）', alone: true },
    { key: 'id', name: '客户ID' },
    { key: 'customerName', name: '客户名称' },
    { key: 'creditCode', name: '统一社会信用代码' },
    { key: 'legalPersonName', name: '法人姓名' },
    { key: 'legalIdCardNo', name: '法人身份证号' },
    { key: 'contacts', name: '联系人姓名' },
    { key: 'customerTel', name: '联系电话' },
    { key: 'address', name: '联系地址' },
    { key: 'tagList', name: '客户标签' },
    { key: 'remarks', name: '备注' },
  ]
  // 企业 支付信息
  const companyPayList = [
    { key: 'bankPic', name: '银行卡照片', alone: true },
    { key: 'accountName', name: '户名' },
    { key: 'bankName', name: '开户行' },
    { key: 'accountNo', name: '银行账号' },
  ]

  return {
    companyBasicInfoList,
    companyPayList,
  }
}
